import { render, staticRenderFns } from "./SiteInsurance.vue?vue&type=template&id=dd824568"
import script from "./SiteInsurance.vue?vue&type=script&lang=js"
export * from "./SiteInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports